import { IContextMenuGroupItem } from '@infotech-soe/metaschema';

import { Caption, CaptionType } from '../../../models/caption/Caption';
import { ClientContext } from '../../context/IContextService';
import CommandViewModel, { CommandListEntryType } from '../CommandViewModel';

import CommandComponent from './CommandComponent';

class GroupItem implements CommandComponent {
  constructor(
    private children: CommandComponent[],
    private name: string,
    private item: IContextMenuGroupItem
  ) {}

  public async serialize(context: ClientContext): Promise<CommandViewModel> {
    const children =
      this.children && this.children.length > 0
        ? await Promise.all(this.children.map(i => i.serialize(context)))
        : [];
    return {
      type: CommandListEntryType.GROUP,
      children,
      name: this.caption.caption,
      caption: this.caption,
      icon: undefined,
      available: this.isAvailable(context),
    };
  }

  public find(name: string): CommandComponent | void {
    for (const child of this.children) {
      const found = child.find(name);
      if (found) {
        return found;
      }
    }
  }

  public isAvailable(context: ClientContext): boolean {
    return this.item.availability
      ? this.item.availability({
          row: context.get('Row') || {},
          parentRow: context.get('ParentRow') || {},
          masterRow: context.get('MasterRow') || {},
          catalog: context.get('Catalog'),
          inParams: context.get('InParams'),
          selectedIds: context.get('SelectedIds') || [],
        })
      : true;
  }
  private get caption(): Caption {
    return {
      type: CaptionType.EXTERNAL,
      caption: this.name,
    };
  }
}

export default GroupItem;
